import { AfterViewInit, ChangeDetectorRef, Component, OnDestroy, OnInit, QueryList, ViewChildren } from '@angular/core';
import { NavigationEnd, NavigationStart, ResolveStart, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { HeaderButtonComponent } from './header-button/header-button.component';
import { UiService } from '../../services/ui.service';
import { AuthenticationService } from '../../modules/auth/services/authentication.service';
import { CurrentUser } from '../../modules/auth/model/CurrentUser';
import { MessagingService } from '../../services/messaging.service';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { NotificationCreateDialogComponent } from '../../dialog/notifications/notification-create-dialog/notification-create-dialog.component';
import { ChatService } from '../../services/messaging/chat.service';
import { LocalStorageService } from '../../services/local-storage.service';
import { SignalrService } from '../../services/socket/signalr.service';
import { NotificationService } from '../../services/messaging/notification.service';
import { NotificationDataModel } from '../../models/messaging/notification-data.model';
import { TaskManagementDialogComponent, TaskQueryModel } from '../../dialog/tasks/task-management-dialog/task-management-dialog.component';
import { SystemTaskDataModel } from '../../models/messaging/system-task-data.model';
import { TaskService } from '../../services/task.service';
import { Globals } from '../../globals';
import { StaticDataService } from '../../services/static-data.service';
import { UserRoleEnum } from '../../models/enum/user-role.enum';
import { InternalMessagingDialogComponent } from '../../dialog/notifications/internal-messaging-dialog/internal-messaging-dialog.component';
import { InternalEmailService } from '../../services/messaging/internal-email.service';
import { InternalEmailDataModel } from '../../models/communication/internal-email-data.model';
import { NotificationDestinationDataModel } from '../../models/messaging/notification-destination-data.model';
import { ColorSchemeDataModel } from '../../models/configuration/color-scheme-data.model';
import { ColorSchemesService } from '../../modules/configuration/color-schemes/color-schemes.service';
import { TdoUserConfigurationModel } from '../../models/configuration/user/tdo-user-configuration.model';
import { UserService } from '../../services/user.service';
import { TDOTaskListService } from "../controls/tdo-task-list/tdo-task-list.service";
import { OfficeLocationsService } from 'src/app/modules/configuration/office-locations/office-locations.service';


@Component({
  standalone: false,
  selector: 'app-tdo-header',
  templateUrl: './tdo-header.component.html',
  styleUrls: ['./tdo-header.component.scss']
})
export class TdoHeaderComponent implements OnInit, AfterViewInit, OnDestroy {

  @ViewChildren(HeaderButtonComponent) middleButtons: QueryList<HeaderButtonComponent>;

  private usersSub?: Subscription;
  private colorSchemesSub?: Subscription;
  private routerEventsSub?: Subscription;
  private signalrSub?: Subscription;
  private currentUserSub?: Subscription;
  private currentReferrerUserSub?: Subscription;
  private currentPatientSub?: Subscription;

  isShowButtons: boolean = true;
  isShowMenu: boolean = false;
  isShowNotifications: boolean = false;

  currentUser: CurrentUser;
  currentPatient: CurrentUser;
  userMode: string = '';
  loggedInDisplayName: string = '';

  //userTaskTypeEnums: EnumValidValueItemModel[] = [];
  //tasks: SystemTaskDataModel[] = [];
  //tasksCalls: SystemTaskDataModel[] = [];
  //tasksReports: SystemTaskDataModel[] = [];
  //tasksOthers: SystemTaskDataModel[] = [];
  internalEmails: InternalEmailDataModel[] = [];

  taskQueryModel = new TaskQueryModel();

  //queuedMeds: number = null;
  //totalNotifications: number = 0;
  numNewNotifications = 0;
  // numPages: number = 0;
  //pages: NotificationDestinationDataModel[] = [];
  instantMessages: NotificationDestinationDataModel[] = [];

  colorSchemes: ColorSchemeDataModel[] = [];
  users: TdoUserConfigurationModel[] = [];
  headerTitle: string = ''
  loadingInfo: boolean = false;
  locationName: string = '';
  showMenuOptions: boolean = false;
  contentUpdateTimeout: ReturnType<typeof setTimeout> | null = null;
  accountAnnouncement: string = '';

  constructor(private readonly router: Router,
    private readonly globals: Globals,
    private readonly dialog: MatDialog,
    public readonly uiService: UiService,
    private readonly authService: AuthenticationService,
    private readonly messagingService: MessagingService,
    private readonly signalrService: SignalrService,
    public readonly notificationService: NotificationService,
    private readonly authenticationService: AuthenticationService,
    private readonly internalEmailService: InternalEmailService,
    public readonly taskService: TaskService,
    public readonly chatService: ChatService,
    private readonly userService: UserService,
    private readonly colorSchemeService: ColorSchemesService,
    private readonly TaskListService: TDOTaskListService,
    private readonly officeLocationsService: OfficeLocationsService,
    private readonly cdr: ChangeDetectorRef) {
    this.currentUserSub = this.authService.currentUser.subscribe(userObj => {
      //console.log('TDOHeaderComponent: currentUserSub fired:', userObj);
      this.currentUser = userObj;
      if (userObj) {
        this.loggedInDisplayName = userObj.userdisplayname;
        this.currentPatient = null;
        this.userMode = 'user';
      }
    });
    this.currentReferrerUserSub = this.authService.currentReferrerUser.subscribe(userObj => {
      //console.log('TDOHeaderComponent: currentReferrerUserSub fired:', userObj);
      if (userObj) {
        this.currentUser = userObj;
        this.loggedInDisplayName = userObj.userdisplayname;
        this.currentPatient = null;
        this.userMode = 'referrer';
      }
    });

    this.currentPatientSub = this.authService.currentPatient.subscribe(patientObj => {
      //console.log('TDOHeaderComponent: currentPatientSub fired:', patientObj);
      this.currentPatient = patientObj;
      if (patientObj) {
        this.currentUser = null;
        this.userMode = 'patient';
      }
    });
  }

  // setupEnums() {
  //   this.userTaskTypeEnums = this.staticDataService.getValidValueItemsByValidValueName('enumUserTaskType');
  // }

  ngOnInit(): void {
    if (this.userMode === '') {
      this.onLogoutClick({});
      return;
    }
    if (this.userMode === 'user')
      this.locationName = this.globals.locationName ? 'Location: ' + this.globals.locationName : '';
    else
      this.locationName = '';

    if (this.authenticationService.currentUserValue && this.userMode == 'user' && this.authenticationService.isLoggedIn()) {
      this.usersSub?.unsubscribe();
      this.usersSub = this.userService.getUsers(this.authenticationService.currentUserValue?.TDOCID)
        .subscribe((users) => {
          this.users = users;
        });
    }
    if (this.authenticationService.currentUserValue && this.authenticationService.isLoggedIn()) {
      this.colorSchemesSub?.unsubscribe();
      this.colorSchemesSub = this.colorSchemeService.getColorSchemes()
        .subscribe((cs) => {
          this.colorSchemes = cs;
        });
    }

    //console.log('TDOHeaderComponent: router events this.routerEventsSub', this.routerEventsSub);

    this.routerEventsSub?.unsubscribe();
    this.routerEventsSub = this.router.events.subscribe((data) => {
      if (data instanceof NavigationStart || data instanceof ResolveStart || data instanceof NavigationEnd) {
        //console.log('TDOHeaderComponent: router events NavigationStart || ResolveStart || NavigationEnd:', data.constructor.name, data);
        if (this.contentUpdateTimeout) {
          clearTimeout(this.contentUpdateTimeout);
        }
        this.contentUpdateTimeout = setTimeout(() => {
          //console.log('TDOHeaderComponent: router events settimeout called');
          this.setContent();
        }, 100);
      }
    });


    this.signalrSub?.unsubscribe();
    this.signalrSub = this.signalrService.messageUser.subscribe((res) => {
      switch (res.messageType) {
        case SignalrService.UPDATE_PAGES:
          // this.getPages();
          // const dest = JSON.parse(res.message as unknown as string) as NotificationDestinationDataModel;
          // if (dest && dest.UserID.toLowerCase() === this.authenticationService.currentUserValue.authdata?.userid.toLowerCase()) {
          //   this.playSound(dest.UserID);
          // }
          break;
        case SignalrService.PAGE_SEEN:
          // const dest1 = JSON.parse(res.message as unknown as string) as NotificationDestinationDataModel;
          // const idx = this.pages.findIndex(p => p.dataNotification.NotificationID === dest1.NotificationID);
          // if (idx > -1) {
          //   this.pages.splice(idx, 1);
          //   this.numNewNotifications--;
          // }
          break;
        case SignalrService.UPDATE_CHAT_MESSAGE:
          this.getInstantMessages();
          break;
        case 'UPDATE_NOTIFICATIONS':
          break;
        case 'UPDATE_INTERNAL_EMAIL':
          this.getInternalEmails();
          break;
        case 'UPDATE_TASKS':
          this.taskService.getTasks(this.taskQueryModel).subscribe((taskRes) => {
            this.calculateNumNotifications();
          });
          break;
      }
    });
  }
  setContent() {
    const url = this.router.url;
    //console.log('TDOHeaderComponent: setContent called for url:', url);

    if (this.middleButtons) {
      //console.log('TDOHeaderComponent: setContent middleButtons found, resetting buttons.');
      this.resetButtons();
    }

    //console.log('TDOHeaderComponent: setContent url:', url);
    if (url === '/' || url.includes('login') || url.includes('configuration') || url.includes('scheduler')
      || url.includes('forms/builder') || url.includes('studio') || url.includes('reports')) {
      //console.log('TDOHeaderComponent: setContent url is in the list of excluded urls');
      this.isShowButtons = false;
      this.showMenuOptions = false;
      if (url.includes('scheduler')) this.headerTitle = "Calendar";
      if (url.includes('configuration')) this.headerTitle = "Settings";
    }
    else {
      //console.log('TDOHeaderComponent: setContent is NOT in the list of excluded urls');
      this.isShowButtons = true;
      this.showMenuOptions = true;
      if (url.includes('landing')) {
        const selectedButton = this.middleButtons?.find(p => p.name === 'home');
        if (selectedButton) {
          selectedButton.isSelected = true;
          this.cdr.detectChanges();
        }
      } else if (url.includes('scheduler')) {
        const selectedButton = this.middleButtons?.find(p => p.name === 'calendar');
        if (selectedButton) {
          selectedButton.isSelected = true;
          this.cdr.detectChanges();
        }
      } else if (url.includes('patientportal')) {
        this.isShowButtons = false;
        this.headerTitle = "Patient Portal";
      } else if (url.includes('referrerportal')) {
        this.isShowButtons = false;
        this.headerTitle = "Referring Doctor Portal";
      }

      //console.log('TDOHeaderComponent: setContent isShowButtons:', this.isShowButtons);
      //console.log('TDOHeaderComponent: setContent showMenuOptions:', this.showMenuOptions);
      //console.log('TDOHeaderComponent: setContent headerTitle:', this.headerTitle);
      //console.log('TDOHeaderComponent: setContent userMode:', this.userMode);

      if (this.isShowButtons && !this.loadingInfo) { //only retrieve tasks and info when buttons are shown
        this.loadingInfo = true;
        this.getInstantMessages();
        this.getTasks();
        this.getInternalEmails();
      }
      //console.log('TDOHeaderComponent: setContent cdr.detectChanges');
      this.cdr.detectChanges();
    }
  }

  getInstantMessages() {
    if (this.authenticationService.currentUserValue && this.userMode === 'user' && this.authenticationService.isLoggedIn()) {
      this.notificationService.getMessagesForUser(this.authenticationService.currentUserValue?.authdata?.userid).subscribe((notifications) => {
        this.instantMessages = notifications;
        this.instantMessages = this.instantMessages.sort((a, b) => {
          const da = new Date(a.xauditModifiedOn);
          const db = new Date(a.xauditModifiedOn);
          return db.getTime() - da.getTime();
        });
        this.calculateNumNotifications();
      });
    }
  }

  getTasks() {
    if (this.authenticationService.isLoggedIn() && this.TaskListService.tasks.getValue().length === 0) {
      //this.TaskListService.loadTaskList();
      this.taskService.getTasks(this.taskQueryModel).subscribe((taskRes) => {
        this.calculateNumNotifications();
      });
    }
  }

  getInternalEmails() {
    if (this.authService.currentUserValue && this.userMode === 'user' && this.authenticationService.isLoggedIn()) {
      this.internalEmailService.getUnreadEmails(this.authService.currentUserValue.authdata.userid).subscribe((ieRes) => {
        this.internalEmails = ieRes;
        this.calculateNumNotifications();
      });
    }
  }

  calculateNumNotifications() {
    this.numNewNotifications = 0;
    this.numNewNotifications += this.TaskListService.tasks.getValue().length;
    this.numNewNotifications += this.internalEmails.length;
    // console.log('calculateNumNotifications', this.numNewNotifications);
  }

  onLogoClick() {
    if (this.userMode === 'user' && !this.isShowButtons)
      window.close();
    else if (this.userMode === 'user')
      this.navigateTo('/landing');
    else if (this.userMode === 'referrer')
      this.navigateTo('/referrerportal/home');
    else if (this.userMode === 'patient')
      this.navigateTo('/patientportal/home');
    else
      this.navigateTo('/');
  }

  onNotificationsClick() {
    this.isShowNotifications = !this.isShowNotifications;
  }

  onUserProfileClick() {
    this.isShowMenu = !this.isShowMenu;
  }

  private navigateTo(path: string) {
    this.router.navigateByUrl(path);
  }

  ngOnDestroy(): void {
    //console.log('TDOHeaderComponent: ngOnDestroy');
    this.usersSub?.unsubscribe();
    this.colorSchemesSub?.unsubscribe();
    this.routerEventsSub?.unsubscribe();
    this.signalrSub?.unsubscribe();
    this.currentUserSub?.unsubscribe();
    this.currentReferrerUserSub?.unsubscribe();
    this.currentPatientSub?.unsubscribe();
    if (this.contentUpdateTimeout) {
      clearTimeout(this.contentUpdateTimeout);
      this.contentUpdateTimeout = null;
    }
  }

  ngAfterViewInit(): void {
    //console.log('TDOHeaderComponent: ngAfterViewInit middleButtons:', this.middleButtons);

    const selectedButton = this.middleButtons?.find(p => p.name === 'home');
    if (selectedButton) {
      selectedButton.isSelected = true;
    }

    if (this.userMode === 'user') {
      this.officeLocationsService.getClientAnnouncements().subscribe((announcements) => {
        announcements.forEach((announcement) => {
          this.uiService.displayMessage(announcement.MessageType === 'AccountWarning' ? 'Warning' : announcement.MessageType, announcement.Message, announcement.MessageTitle);
        });
        const accountWarning = announcements.find(announcement => announcement.MessageType === 'AccountWarning');
        this.accountAnnouncement = accountWarning?.Message ?? '';
      });
    }
    this.setContent();
    this.cdr.detectChanges();
    //console.log('TDOHeaderComponent: ngAfterViewInit cdr.detectChanges');
  }

  onMiddleButtonClick(event) {
    const clicked = event as HeaderButtonComponent;
    if (clicked.isPage) {
      this.resetButtons();
      clicked.isSelected = true;
      this.cdr.detectChanges();
    }



    switch (clicked.name) {
      case 'home':
        this.navigateTo('/landing');
        break;
      case 'search':
        // this.navigateTo('/landing');
        break;
      case 'video':
        // this.navigateTo('/landing');
        break;
      case 'notes':
        // this.navigateTo('/landing');
        break;
      case 'communication':
        this.messagingService.sendComponentMessage('Toggle-Live-Chat-Display', {});
        break;
      case 'calendar':
        // old calenar not in use anymore: use z-calendar
        this.uiService.openSchedulerWindow();
        break;
      case 'z-calendar':
        this.uiService.openSchedulerWindow();
        break;
      case 'pid':
        this.uiService.openPidWindow();
        break;
      case 'comms':
        this.uiService.openCommsWindow();
        break;
      case 'marea':
        this.uiService.openMareaWindow();
        break;
    }
  }

  onProfileClick() {
    this.isShowMenu = false;
    const profilePath = this.userMode == 'user' ? '/configuration/practice-users' : '/patientportal/profile';
    const profileUrl = this.router.serializeUrl(this.router.createUrlTree([profilePath]));
    const windowOptions = [
      'toolbar=no',
      'location=no',
      'menubar=no',
      'height=' + screen.height,
      'width=' + screen.width,
      'fullscreen=yes'
    ].join(',');
    this.messagingService.openPopUpWindow(profileUrl, windowOptions, 'tdoProProfileWindow', {}, [], true, 'tdoProProfileWindow');
  }

  onTitleClick() {
    this.onLogoClick();

  }

  onSettingsClick() {
    this.isShowMenu = false;
    const settingsUrl = this.router.serializeUrl(
      this.router.createUrlTree(['/configuration'])
    );
    let windowOptions = [
      'toolbar=no',
      'location=no',
      'menubar=no',
      'height=' + screen.height,
      'width=' + screen.width,
      'fullscreen=yes' // only works in IE, but here for completeness
    ].join(',');
    let storageName = 'tdoProConfigurationWindow';
    let itemToStore = {};
    let postClosureEvents = [];
    let tdoProConfigurationWindow = this.messagingService.openPopUpWindow(settingsUrl, windowOptions, storageName, itemToStore, postClosureEvents, true, 'tdoProConfigurationWindow');
  }

  onFeeScheduleClick() {
    this.isShowMenu = false;
    this.router.navigateByUrl('fee-schedule');
  }

  onLogoutClick(event: any) {
    //console.log('TDOHeaderComponent: onLogoutClick called');
    //console.log('TDOHeaderComponent: onLogoutClick userMode:', this.userMode);
    this.isShowMenu = false;
    this.authService.logout();
    let loginRoute = '/login';
    let returnUrl = '/';
    let lt = '';
    if (this.userMode === 'patient') {
      loginRoute = '/patientLogin';
      returnUrl = '/patientportal/home';
    }
    else if (this.userMode === 'referrer') {
      // Navigate to unified /login with no lt param so the
      // login page doesn't pre-set loginType to 'referring doctor'
      returnUrl = '/referrerportal/home';
      lt = 'r';
    }

    this.messagingService.alertChildrenOnClosure();
    this.uiService.closePopupWindows();
    this.TaskListService.tasks.next([]);
    this.TaskListService.callTasks.next([]);
    this.TaskListService.reportTasks.next([]);
    this.TaskListService.financeTasks.next([]);
    this.TaskListService.loadingTasks = false;
    this.router.navigate([loginRoute], { queryParams: { returnUrl, lt } });
  }

  private resetButtons() {
    for (const b of this.middleButtons) {
      b.isSelected = false;
      b.isHovered = false;
    }
  }

  onOpenInstantMessaging(destination: NotificationDestinationDataModel = null) {
    const config = new MatDialogConfig();
    config.panelClass = 'dialog';
    config.data = destination;
    this.dialog.open(NotificationCreateDialogComponent, config);
  }

  onNotificationSeenClick(notification: NotificationDataModel, isPage = false) {
    if (isPage) {
      // const page = this.pages.find(p => p.dataNotification.NotificationID === notification.NotificationID);
      // if (page) {
      //   if (page.UserID.toLowerCase() !== this.authenticationService.currentUserValue.authdata.userid.toLowerCase()) {
      //     return;
      //   }
      // }
    }

    this.notificationService.markNotificationAsSeen(notification).subscribe((res) => {
      let idx = -1;
      if (isPage) {
        // idx = this.pages.findIndex(p => p.dataNotification.NotificationID === notification.NotificationID);
        // if (idx > -1) {
        //   this.pages.splice(idx, 1);
        //   this.numNewNotifications--;
        // }
      } else {
        idx = this.instantMessages.findIndex(p => p.dataNotification.NotificationID === notification.NotificationID);
        if (idx > -1) {
          this.instantMessages.splice(idx, 1);
          this.numNewNotifications--;
        }
      }
    });
  }

  onOpenNotificationToFrontDialog() {
    this.router.navigateByUrl('landing/notes-to-front');
  }

  onOpenTaskManagementDialog() {
    const config = new MatDialogConfig();
    config.panelClass = 'dialog';
    this.dialog.open(TaskManagementDialogComponent, config);
  }

  getDate(date: Date | string) {
    const da = new Date(date);
    return da.toLocaleString();
  }

  isPastDue(task: SystemTaskDataModel) {
    const taskDueDate = new Date(task.DueDate);
    return taskDueDate < new Date();
  }

  isHasRole(val: string) {
    switch (val) {
      case 'communication':
        return this.authenticationService.currentUserRolesIds.includes(UserRoleEnum.Communications);
      case 'scheduler':
        return this.authenticationService.currentUserRolesIds.includes(UserRoleEnum.Scheduler);
      case 'noteToFront':
        return this.authenticationService.currentUserRolesIds.includes(UserRoleEnum.NoteToFront);
    }

    return false;
  }

  onInternalCommunicationClick() {
    const config = new MatDialogConfig();
    config.panelClass = 'dialog';
    this.dialog.open(InternalMessagingDialogComponent, config).afterClosed().subscribe((res) => {

    });
  }

  markInternalEmailAsRead(email: InternalEmailDataModel) {
    const myDestination = email.dataInternalEmailDestanations.find(p => p.UserID === this.authService.currentUserValue.authdata.userid);
    if (myDestination) {
      this.internalEmailService.markAsRead(myDestination.IEmailToID).subscribe(() => {
        const idx = this.internalEmails.findIndex(p => p === email);
        if (idx > -1) {
          this.internalEmails.splice(idx, 1);
          this.numNewNotifications--;
        }
      });
    }
  }

  getBackgroundColor(userId: string) {
    const user = this.users.find(p => p.UserID.toLowerCase() === userId.toLowerCase());
    if (user) {
      const scheme = this.colorSchemes.find(p => p.ColorSchemeId.toLowerCase() === user.ColorSchemeID.toLowerCase());
      if (scheme) {
        return scheme.BackColor;
      }
    }
  }

  getForColor(userId: string) {
    const user = this.users.find(p => p.UserID.toLowerCase() === userId.toLowerCase());
    if (user) {
      const scheme = this.colorSchemes.find(p => p.ColorSchemeId.toLowerCase() === user.ColorSchemeID.toLowerCase());
      if (scheme) {
        return scheme.ForeColor;
      }
    }
  }

  getName(userId: string) {
    const user = this.users.find(p => p.UserID.toLowerCase() === userId.toLowerCase());
    if (user) {
      return user.FirstName + ' ' + user.LastName;
    }
  }

  playSound(userId: string) {
    const user = this.users.find(p => p.UserID.toLowerCase() === userId.toLowerCase());
    if (user) {
      const audio = new Audio();
      audio.src = 'assets/sounds/user/' + user.UserSound;
      audio.load();
      audio.play();
    }
  }

  getContactByDate(xauditModifiedOn: Date) {
    const today = new Date();
    const d = new Date(xauditModifiedOn);
    if (today.getDate() === d.getDate()) {
      const time = d.toLocaleTimeString();
      return `Today @ ${time}`;
    } else {
      return d.toLocaleString();
    }
  }
  onSupportClick($event: any) {
    this.isShowMenu = false;
    this.uiService.openSupportWindow();
  }

  onChangeLogClick($event: any) {
    // Opens the standalone static Change Log page (see src/assets/change-log/index.html).
    // Uses window.open rather than the Angular Router so the page loads without
    // bootstrapping Angular. Trailing slash matches the hosting rewrite for the clean URL.
    this.isShowMenu = false;
    window.open('assets/change-log/index.html', '_blank', 'noopener,noreferrer');
  }

  onAccountAnnouncementClick() {
    this.accountAnnouncement = '';
    this.cdr.detectChanges();
  }

}
